import { createFileRoute } from "@tanstack/react-router";
import { GamificationPage } from "@/modules/gamification/presentation/pages/GamificationPage";

export const Route = createFileRoute("/_authenticated/gamification")({
  component: GamificationPage,
});
